
import { RangerEntityDecorator } from '../../ranger/model/ranger.decorator';
import { Ranger } from '../../ranger/model/ranger.model';
import { AMMUNITION_STOCK_EVENT_METADATA } from './ammunition-stock-event.metadata';
import { AmmunitionStockEvent } from './ammunition-stock-event.model';
import { AmmunitionStockEntityDecorator } from './ammunition-stock.decorator';
import { AmmunitionStock } from './ammunition-stock.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class AmmunitionStockEventEntityDecoratorBase extends GenericEntityDecorator<AmmunitionStockEvent, number> {
  constructor() {
    super(AMMUNITION_STOCK_EVENT_METADATA, {
      get ammunitionStock(): EntityDecorator<AmmunitionStock, number> {
        return new AmmunitionStockEntityDecorator();
      },
      get ranger(): EntityDecorator<Ranger, number> {
        return new RangerEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.ammunitionStockEventId == null) {
      return null;
    }
    return parseInt(params.ammunitionStockEventId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: AmmunitionStockEvent): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




